import type { CSSProperties } from 'react'
import { cn } from '@/lib/utils'

/** A shimmering placeholder (`.skel`). Give it the height of what it stands in for. */
export function Skeleton({ height, width, className, style }: { height: number | string; width?: number | string; className?: string; style?: CSSProperties }) {
  return <span className={cn('skel', className)} style={{ display: 'block', height, width, ...style }} aria-hidden="true" />
}

/** A stack of skeleton rows, the prototype's loading treatment for lists and tables. */
export function SkeletonRows({ rows = 4, height = 34, gap = 12 }: { rows?: number; height?: number; gap?: number }) {
  return (
    <div style={{ display: 'grid', gap }} aria-busy="true" aria-label="Loading">
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} height={height} />
      ))}
    </div>
  )
}
